<template>
  <main role="main" class="main bg-navy">
    <div class="bg-navy d-block d-md-none">
      <b-row class="no-gutters">
        <b-col class="text-center">
          <b-button type="button" variant="link" class="color-white float-left py-3" to="/home">
            <feather type="arrow-left"></feather>
          </b-button>
          <span class="d-inline-block h-100 title-w-60">
            <span class="d-table h-100">
              <span class="d-table-cell align-middle">
                <strong class="color-white">Organisational Structure</strong>
              </span>
            </span>
          </span>
        </b-col>
      </b-row>
    </div>
    <div class="mobile-vh min-h-100 p-4 p-md-5 bg-white mobi-rounded-top">
      <b-row class="custom-height">
        <b-col lg="10" offset-lg="1">
          <profile-menu></profile-menu>
          <h2 class="mobile-size-reduce color-navy-blue mb-3">Organisational Structure</h2>
          <h5 class="mb-3 d-none d-md-block"><strong class="color-navy-blue">Please note:</strong> When updating these details your organisation profile will automatically be reverified.</h5>
          <p class="mb-3 d-block d-md-none"><strong class="color-navy-blue">Please note:</strong> When updating these details your organisation profile will automatically be reverified.</p>
          <p class="line-height-1"><small><strong>Note:</strong> All these individuals will automatically be granted access to this organisation on Truzo platform after their profiles are verified and they have set up their login credentials. Should they choose not set up their login credentials now, they can do so later. In the meanwhile we will keep them in all email communications Truzo platform sends out related to activities for this Organisation.</small></p>
          <div v-if="companyLoaded === 'loaded'">
            <b-table striped hover :items="parties" :fields="tableFields" responsive="sm">
              <template v-slot:cell(relationship)="data">
                <span :class="data.item.relationship === 'Unknown' ? 'text-danger font-weight-600' : ''">
                  {{ data.item.relationship.replace(/,/g, ', ') }}
                  <small v-if="data.item.relationship === 'Unknown'"><br />Please, provide designation.</small>
                </span>
              </template>
              <template v-slot:cell(_id)="data">
                <a href="#" @click.prevent="editUser(data.item)">
                  <feather type="edit" stroke="#9190a8" size="14px"></feather>
                </a>
                <a href="#" @click.prevent="deleteUser(data.item._id)">
                  <feather type="trash-2" stroke="#9190a8" size="14px"></feather>
                </a>
                <b-modal :id="'edit_' + data.item._id" size="md" centered hide-header hide-footer>
                  <h4 class="font-weight-400 color-grey mb-3">{{ data.item.name }}</h4>
                  <b-row>
                    <b-col xl="9" cols="12">
                      <vue-form-generator :model="edit" :schema="edit_schema" :options="formOptions" ref="edit_form"></vue-form-generator>
                    </b-col>
                    <b-col xl="3" offset-xl="0" offset="6" cols="6">
                      <b-button variant="custom" pill block @click="saveUser(data.item._id)">Save</b-button>
                    </b-col>
                  </b-row>
                </b-modal>
              </template>
            </b-table>
          </div>
          <hr style="width: 80%" />
          <b-form>
            <h5 class="font-weight-400 color-grey mt-3 mb-2">Add New Party</h5>
            <b-row class="mb-2 mt-3">
              <b-col md="6" class="pl-3">
                <maz-select
                  v-model="details.designation"
                  placeholder="Designation"
                  clearable
                  required
                  multiple
                  :success="details.designation !== null && details.designation !== ''"
                  :options="['Shareholder', 'CEO', 'Director', 'Authorised Representative'].map(_designation => ({ value: _designation, label: _designation }))"></maz-select>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-phone-number-input v-model="details.mobile" placeholder="Mobile Number" required defaultCountryCode="ZA"></maz-phone-number-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-input v-model="details.email" placeholder="Email Address" required :success="details.email && details.email.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.first_name" placeholder="First Name" required :success="details.first_name && details.first_name.length >= 2"></maz-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-input v-model="details.middle_name" placeholder="Middle Name(s)" :success="details.middle_name && details.middle_name.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.surname" placeholder="Surname" required :success="details.surname && details.surname.length >= 2"></maz-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-picker v-model="details.dob" placeholder="Date of Birth" required :success="details.dob && details.dob.length >= 2" format="YYYY-MM-DD"></maz-picker>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-select v-model="details.nationality" placeholder="Country of Nationality" clearable required :success="details.nationality !== null && details.nationality !== ''" :options="countries.map(_nationality => ({ value: _nationality.code, label: _nationality.name }))"></maz-select>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-select v-model="details.id_type" placeholder="Type of ID Document" clearable required :success="details.id_type !== null && details.id_type !== ''" :options="['RSA ID Document', 'Non-RSA Passport'].map(_id_type => ({ value: _id_type, label: _id_type }))"></maz-select>
              </b-col>
              <b-col md="6" class="pl-0" v-if="details.id_type === 'RSA ID Document'">
                <maz-input v-model="details.id_number" placeholder="ID Number" required :success="details.id_number && details.id_number.length >= 2"></maz-input>
              </b-col>
              <b-col md="6" class="pl-0" v-else>
                <maz-input v-model="details.passport_number" placeholder="Non-RSA Passport Number" required :success="details.passport_number && details.passport_number.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="details.id_type === 'Non-RSA Passport'">
              <b-col md="6" class="pl-3">
                <maz-picker v-model="details.passport_expiry" placeholder="Passport Expiry Date" required :success="details.passport_expiry && details.passport_expiry.length >= 2" no-time></maz-picker>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-select v-model="details.passport_country" placeholder="Country of Nationality" clearable required :success="details.passport_country !== null && details.passport_country !== ''" :options="countries.map(_nationality => ({ value: _nationality.code, label: _nationality.name }))"></maz-select>
              </b-col>
            </b-row>
            <b-row class="mb-2" v-if="details.id_type === 'Non-RSA Passport'">
              <b-col md="6" class="pl-3">
              </b-col>
            </b-row>
            <hr class="mt-3" style="width: 80%" />
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.unit_number" placeholder="Unit Number" type='number' :success="details.unit_number !== null && details.unit_number !== ''" :max="10000" no-buttons></maz-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-input v-model="details.complex" placeholder="Complex Name" :success="details.complex && details.complex.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.street_address" placeholder="Street Number & Name" required :success="details.street_address && details.street_address.length >= 2"></maz-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-input v-model="details.suburb" placeholder="Suburb Or District" required :success="details.suburb && details.suburb.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.city" placeholder="City or Town" required :success="details.city && details.city.length >= 2"></maz-input>
              </b-col>
              <b-col md="6" class="pl-0">
                <maz-select v-model="details.country" placeholder="Country" clearable required :success="details.country !== null && details.country !== ''" :options="countries.map(_country => ({ value: _country.code, label: _country.name }))"></maz-select>
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col md="6" class="pl-3">
                <maz-input v-model="details.postal_code" placeholder="Postal Code" required :success="details.postal_code && details.postal_code.length >= 2"></maz-input>
              </b-col>
            </b-row>
            <b-form-group class="col-xl-12 btn-bottom px-md-0">
              <b-row>
                <b-col lg="6" offset-lg="6" cols="12">
                  <loading-button :replace="saving !== null">
                    <b-button variant="custom" @click="save()" pill block class="mt-3" :disabled="!details.designation || myRole !== 'Administrators'">Add</b-button>
                  </loading-button>
                </b-col>
              </b-row>
            </b-form-group>
          </b-form>
        </b-col>
      </b-row>
    </div>
  </main>
</template>

<script>
import ProfileMenu from '@/components/organisation/ProfileMenu'
import { mapActions, mapState } from 'vuex'

const asyncIdNumberValidator = function (value) {
  const isNumber = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n)
  }

  return new Promise((resolve, reject) => {
    if (!value) resolve([])

    const idNumber = value.toString()
    if (idNumber.length !== 13 || !isNumber(idNumber)) {
      console.log('1st')
      resolve(['Not a valid RSA ID Number.'])
    }

    const _year = parseInt(idNumber.substring(0, 2)) < 15 ? '20' + idNumber.substring(0, 2) : '19' + idNumber.substring(0, 2)
    const tempDate = new Date(_year, idNumber.substring(2, 4) - 1, idNumber.substring(4, 6))
    const idDate = tempDate.getDate()
    const idMonth = tempDate.getMonth()

    const _yearEq = (tempDate.getFullYear() + '').substring(2, 4) === idNumber.substring(0, 2)
    const _monthEq = idMonth === (idNumber.substring(2, 4) - 1)
    const _dayEq = idDate === parseInt(idNumber.substring(4, 6))
    if (!(_yearEq && _monthEq && _dayEq)) {
      console.log('2nd')
      resolve(['Not a valid RSA ID Number.'])
    }

    let tempTotal = 0
    let checkSum = 0
    let multiplier = 1
    for (var i = 0; i < 13; ++i) {
      tempTotal = parseInt(idNumber.charAt(i)) * multiplier
      if (tempTotal > 9) {
        tempTotal = parseInt(tempTotal.toString().charAt(0)) + parseInt(tempTotal.toString().charAt(1))
      }
      checkSum = checkSum + tempTotal
      multiplier = (multiplier % 2 === 0) ? 1 : 2
    }
    if ((checkSum % 10) !== 0) {
      console.log('3rd')
      resolve(['Not a valid RSA ID Number.'])
    }

    resolve([])
  })
}

export default {
  components: {
    ProfileMenu
  },
  data () {
    return {
      saving: null,
      tableFields: [
        { key: 'name', sortable: true, label: 'Name' },
        { key: 'email', sortable: true, label: 'Email' },
        { key: 'relationship', sortable: true, label: 'Designation' },
        { key: '_id', sortable: false, label: 'Actions', class: 'text-right' }
      ],
      edit: {
        designation: null
      },
      details: {
        designation: null,
        first_name: null,
        middle_name: null,
        surname: null,
        id_type: 'RSA ID Document',
        id_number: null,
        dob: null,
        nationality: 'ZA',
        passport_number: null,
        passport_expiry: null,
        passport_country: null,
        passport_copy: null,
        mobile: '',
        email: null,
        unit_number: null,
        complex: null,
        street_address: null,
        suburb: null,
        city: null,
        postal_code: null,
        country: 'ZA',
        user_id: null
      },
      designation_schema: {
        fields: [
          {
            type: 'checklist',
            placeholder: 'Designation',
            model: 'designation',
            multi: true,
            multiSelect: true,
            values: (model, schema) => {
              if (this.companyLoaded === 'loaded') {
                if (this.companies.company) {
                  if (!this.companies.company.company_type) {
                    return ['Company type is not specified, please specify in details.']
                  } else if (this.companies.company.company_type === 'Sole Proprietor') {
                    return ['Owner']
                  } else if (this.companies.company.company_type === 'Partnership') {
                    return ['Partner', 'Authorised Representative']
                  } else if (this.companies.company.company_type === 'Charity / Foundation / Non-Profitable Organisation') {
                    return ['Senior Managing Official', 'Member / Official']
                  } else if (this.companies.company.company_type === 'Trust') {
                    return ['Trustee', 'Beneficiary', 'Founder', 'Settlor', 'Donor', 'Protector', 'Authorised Representative']
                  } else {
                    return ['Shareholder', 'CEO', 'Director', 'Authorised Representative']
                  }
                } else {
                  return ['Company details not loaded, please refresh the page.']
                }
              } else {
                return ['Loading company details']
              }
            },
            required: true,
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      edit_schema: {
        fields: [
          {
            type: 'checklist',
            placeholder: 'Designation',
            model: 'designation',
            multi: true,
            multiSelect: true,
            values: (model, schema) => {
              if (this.companyLoaded === 'loaded') {
                if (this.companies.company) {
                  if (!this.companies.company.company_type) {
                    return ['Company type is not specified, please specify in details.']
                  } else if (this.companies.company.company_type === 'Sole Proprietor') {
                    return ['Owner']
                  } else if (this.companies.company.company_type === 'Partnership') {
                    return ['Partner', 'Authorised Representative']
                  } else if (this.companies.company.company_type === 'Charity/Foundation/Non-Profitable Organisation') {
                    return ['Senior Managing Official', 'Member / Official']
                  } else if (this.companies.company.company_type === 'Trust') {
                    return ['Trustee', 'Beneficiary', 'Founder', 'Settlor', 'Donor', 'Protector', 'Authorised Representative']
                  } else if (this.companies.company.company_type === 'Closed Corporation (CC)') {
                    return ['Member', 'Authorised Representative']
                  } else {
                    return ['Shareholder', 'CEO', 'Director', 'Authorised Representative']
                  }
                } else {
                  return ['Company details not loaded, please refresh the page.']
                }
              } else {
                return ['Loading company details']
              }
            },
            required: true
          }
        ]
      },
      details_schema: {
        fields: [
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'First Name',
            model: 'first_name',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Middle Name(s)',
            model: 'middle_name',
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Surname',
            model: 'surname',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'date-input',
            placeholder: 'Date of Birth',
            model: 'dob',
            required: true,
            validator: ['required'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Country of Nationality',
            model: 'nationality',
            values: (model, schema) => {
              const _countries = []
              this.countries.forEach(country => {
                _countries.push({ id: country.code, name: country.name })
              })
              return _countries
            },
            required: true,
            selectOptions: {
              noneSelectedText: 'Country of Nationality',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      extra_schema: {
        fields: [
          {
            type: 'select',
            placeholder: 'Type of ID Document',
            model: 'id_type',
            values: ['RSA ID Document', 'Non-RSA Passport'],
            required: true,
            selectOptions: {
              noneSelectedText: 'Type of ID Document',
              hideNoneSelectedText: false
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'RSA ID Number',
            model: 'id_number',
            validator: ['required', asyncIdNumberValidator],
            visible: function (model) {
              return model && model.id_type === 'RSA ID Document'
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Non-RSA Passport Number',
            model: 'passport_number',
            required: true,
            validator: ['string'],
            visible: function (model) {
              return model && model.id_type === 'Non-RSA Passport'
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'date-input',
            placeholder: 'Passport Expiry Date',
            model: 'passport_expiry',
            required: true,
            validator: ['required'],
            visible: function (model) {
              return model && model.id_type === 'Non-RSA Passport'
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Country of Issue',
            model: 'passport_country',
            values: (model, schema) => {
              const _countries = []
              this.countries.forEach(country => {
                _countries.push({ id: country.code, name: country.name })
              })
              return _countries
            },
            required: true,
            validator: ['required'],
            selectOptions: {
              noneSelectedText: 'Country of Issue',
              hideNoneSelectedText: false
            },
            visible: function (model) {
              return model && model.id_type === 'Non-RSA Passport'
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'file-input',
            placeholder: 'Upload Passport Copy',
            model: 'passport_copy',
            required: true,
            validator: ['required'],
            visible: function (model) {
              return model && model.id_type === 'Non-RSA Passport'
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      contact_schema: {
        fields: [
          {
            type: 'tel-input',
            label: 'Mobile number',
            placeholder: 'Mobile number',
            model: 'mobile',
            required: true,
            visible: function (model) {
              return model && !model.user_id
            },
            validator: ['required', 'telNumber'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'tel-input',
            label: 'Mobile number',
            placeholder: 'Mobile number',
            model: 'mobile',
            visible: function (model) {
              return model && model.user_id
            },
            validator: ['telNumber'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'email',
            label: 'Email Address',
            placeholder: 'Email Address',
            model: 'email',
            visible: function (model) {
              return model && model.user_id
            },
            validator: ['email'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'email',
            label: 'Email Address',
            placeholder: 'Email Address',
            model: 'email',
            required: true,
            visible: function (model) {
              return model && !model.user_id
            },
            validator: ['email'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      address_schema: {
        fields: [
          {
            type: 'input',
            inputType: 'number',
            placeholder: 'Unit Number',
            model: 'unit_number',
            min: 0,
            max: 9999,
            validator: ['number'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Complex Name',
            model: 'complex',
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Street Number & Name',
            model: 'street_address',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Suburb Or District',
            model: 'suburb',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'City Or Town',
            model: 'city',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'select',
            placeholder: 'Country of Residence',
            model: 'country',
            values: (model, schema) => {
              const _countries = []
              this.countries.forEach(country => {
                _countries.push({ id: country.code, name: country.name })
              })
              return _countries
            },
            required: true,
            selectOptions: {
              hideNoneSelectedText: true
            },
            styleClasses: 'col-12 col-xl-6 pl-0'
          },
          {
            type: 'input',
            inputType: 'text',
            placeholder: 'Postal Code',
            model: 'postal_code',
            required: true,
            validator: ['string'],
            styleClasses: 'col-12 col-xl-6 pl-0'
          }
        ]
      },
      formOptions: {
        validationErrorClass: 'has-error',
        validationSuccessClass: 'has-success',
        validateAfterChanged: false,
        validateAsync: true
      }
    }
  },
  computed: {
    ...mapState({
      accounts: state => state.companyAccounts,
      auth: state => state.auth.user,
      authExt: state => state.authExt,
      countries: state => state.country.countries,
      companies: state => state.company,
      compUser: state => state.companyUser
    }),
    getUserStatus () {
      return this.authExt.status
    },
    companyLoaded () {
      return this.companies.status
    },
    companyUserSaved () {
      return this.compUser.status === 'saved'
    },
    myRole () {
      if (this.auth && this.auth.user && this.auth.user.role) {
        return this.auth.user.role.name
      } else {
        return 'Unknown'
      }
    },
    parties () {
      if (this.companyLoaded === 'loaded') {
        if (this.companies.company && this.companies.company.users) {
          return this.companies.company.users.filter(user => user.relationship !== 'Registered User')
        } else {
          return []
        }
      } else {
        return []
      }
    }
  },
  created () {
    this.getCompany()
  },
  methods: {
    ...mapActions('authExt', {
      getUser: 'getUser'
    }),
    ...mapActions('company', {
      getCompany: 'get'
    }),
    ...mapActions('companyUser', {
      addExisting: 'addExisting',
      addNew: 'addNew',
      deleteUser: 'delete',
      saveCompanyUser: 'saveDesignation'
    }),
    getCountry: function (code) {
      return this.countries.find(country => country.code === code).name
    },
    editUser: function (item) {
      this.edit.designation = !item.relationships && item.relationships.length === 0 ? null : item.relationships
      this.$bvModal.show('edit_' + item._id)
    },
    saveUser: async function (id) {
      const _response = await this.$refs.edit_form.validate()

      if (_response.length === 0) {
        this.saving = id
        this.saveCompanyUser({ id: id, payload: this.edit })
      }
    },
    save: async function () {
      if (this.details.user_id) {
        this.saving = this.details.user_id
        this.addExisting({ id: this.saving, payload: this.details })
      } else {
        this.saving = this.details.email
        this.addNew(this.details)
      }
    }
  },
  watch: {
    companyUserSaved: function (value) {
      if (value) {
        this.getCompany()
        this.$bvModal.hide('edit_' + this.saving)
        this.saving = null
        this.details = {
          designation: null,
          first_name: null,
          middle_name: null,
          surname: null,
          id_type: 'RSA ID Document',
          id_number: null,
          dob: null,
          nationality: 'ZA',
          passport_number: null,
          passport_expiry: null,
          passport_country: null,
          passport_copy: null,
          mobile: '',
          email: null,
          unit_number: null,
          complex: null,
          street_address: null,
          suburb: null,
          city: null,
          postal_code: null,
          country: 'ZA',
          user_id: null
        }
      }
    },
    'details.mobile': function (value) {
      if (value && value.length >= 10) {
        this.getUser(value)
      }
    },
    'details.email': function (value) {
      if (value && value.length >= 10) {
        this.getUser(value)
      }
    },
    getUserStatus: function (value) {
      if (value === 'loaded') {
        this.details.user_id = this.authExt.user._id
      }
    }
  }
}
</script>
